import Vue from 'vue';
import VueI18n from 'vue-i18n'
import { nl } from './translations/nl'
import { en } from './translations/en'

Vue.use(VueI18n)

const messages = {
    en: en,
    nl: nl
}

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})

